/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ group: NonNullable<unknown> }} Views_Summary_GroupedInputs */

const en_views_summary_grouped = /** @type {(inputs: Views_Summary_GroupedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`grouped by ${i?.group}`)
};

const de_views_summary_grouped = /** @type {(inputs: Views_Summary_GroupedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`gruppiert nach ${i?.group}`)
};

/**
* | output |
* | --- |
* | "grouped by {group}" |
*
* @param {Views_Summary_GroupedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const views_summary_grouped = /** @type {((inputs: Views_Summary_GroupedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Views_Summary_GroupedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_views_summary_grouped(inputs)
	return en_views_summary_grouped(inputs)
});